{
  "name": "piscina-locks",
  "version": "3.1.1",
  "description": "A Web Locks API implementation for Node.js",
  "keywords": [
    "worker_threads",
    "locks"
  ],
  "author": "James M Snell <jasnell@gmail.com>",
  "license": "MIT",
  "main": "./dist/lib/index.js",
  "module": "./dist/lib/index.mjs",
  "types": "./dist/lib/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/lib/index.d.mts",
        "default": "./dist/lib/index.mjs"
      },
      "require": {
        "types": "./dist/lib/index.d.ts",
        "default": "./dist/lib/index.js"
      },
      "types": "./dist/lib/index.d.ts",
      "default": "./dist/lib/index.js"
    }
  },
  "scripts": {
    "prebuildify": "cross-env prebuildify --napi --strip --target $(node -v)",
    "prebuildify:ci": "cross-env prebuildify --napi --strip --target $NODE_VERSION",
    "install": "node-gyp-build",
    "build": "npm run prebuildify && tsup",
    "build:ci": "npm run prebuildify:ci && tsup",
    "lint": "standardx \"**/*.{ts,mjs,js,cjs}\" | snazzy",
    "test-only": "tap --ts",
    "test": "npm run lint && npm run build && npm run test-only",
    "test:ci": "npm run lint && npm run build:ci && npm run test-only",
    "prepack": "npm run build"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/piscinajs/piscina-locks.git"
  },
  "eslintConfig": {
    "rules": {
      "semi": [
        "error",
        "always"
      ],
      "no-unused-vars": "off",
      "no-use-before-define": "off",
      "no-unreachable-loop": "off",
      "no-dupe-class-members": "off",
      "@typescript-eslint/no-unused-vars": "error"
    },
    "globals": {
      "SharedArrayBuffer": true,
      "Atomics": true,
      "AbortController": true,
      "MessageChannel": true
    }
  },
  "standardx": {
    "parser": "@typescript-eslint/parser",
    "plugins": [
      "@typescript-eslint/eslint-plugin"
    ]
  },
  "devDependencies": {
    "@types/node": "^22.10.2",
    "@typescript-eslint/eslint-plugin": "^6.14.0",
    "@typescript-eslint/parser": "^6.14.0",
    "abort-controller": "^3.0.0",
    "cross-env": "^7.0.3",
    "prebuildify": "^6.0.1",
    "snazzy": "^9.0.0",
    "standardx": "^7.0.0",
    "tap": "^15.0.6",
    "ts-node": "^10.9.2",
    "tsup": "^8.2.4",
    "typescript": "^5.3.3"
  },
  "dependencies": {
    "node-addon-api": "^8.3.0",
    "node-gyp-build": "^4.2.3"
  }
}
